import {getSignType} from '../../sign-type';

export function connectStats(isFormSignup, tag, signSource) {
    const isSignup = isFormSignup || getSignType() === 'signup';

    if (isSignup && tag && tag.attr('data-gtm-signup-confirmed')) {
        Hop.gtm.push(JSON.parse(tag.attr('data-gtm-signup-confirmed')));
    }

    if (window.SIGN_UP_GTM_ENABLED) {
        if (signSource === 'facebook') {
            if (isSignup) {
                Hop.gtm.push({category: '_signup', action: '_signup_facebook', label: '_signup_popin'});
            } else {
                Hop.gtm.push({category: '_signin', action: '_signin_facebook', label: '_signin_popin'});
            }
        } else if (signSource === 'google') {
            if (isSignup) {
                Hop.gtm.push({category: '_signup', action: '_signup_google', label: '_signup_popin'});
            } else {
                Hop.gtm.push({category: '_signin', action: '_signin_google', label: '_signin_popin'});
            }
        }
    }

    if (isSignup && tag) {
        Hop.safeGA('send', 'event', 'account', 'create', tag.attr('data-ga-signup'));
    }

    if (isSignup && tag && tag.attr('data-additional-ga-on-signup')) {
        sendGaFromConfig(tag.attr('data-additional-ga-on-signup'));
    }

    if (!isSignup && tag && tag.attr('data-additional-ga-on-signin')) {
        sendGaFromConfig(tag.attr('data-additional-ga-on-signin'));
    }
}

export function sendGaFromConfig(cfgJson) {
    try {
        let cfgs = JSON.parse(cfgJson);
        cfgs = Array.isArray(cfgs) ? cfgs : [cfgs];
        cfgs.forEach((cfg) => {
            Hop.safeGA('send', 'event', cfg.category, cfg.action, cfg.label, cfg.value);
        });
    } catch (e) {
        Hop.logError(e);
    }
}
